var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.status == 'Draft')?_c('div',[_vm._v(_vm._s(_vm.$t("inspections.draft")))]):_c('div',[_vm._v(_vm._s(_vm.$t("inspections.finished")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }